import { render } from "./BankCollectedAddBatch.vue?vue&type=template&id=d6b44e4a"
import script from "./BankCollectedAddBatch.vue?vue&type=script&lang=js"
export * from "./BankCollectedAddBatch.vue?vue&type=script&lang=js"

import "./BankCollectedAddBatch.vue?vue&type=style&index=0&id=d6b44e4a&lang=less"

import exportComponent from "D:\\Project\\远创人力\\开发\\前端\\yc_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__